import $ from 'jquery';
import EFOcats_event_addCheck from '../../../core/v2/event/efocats_event_addCheck';

export default class EFOcats_curves_event_addCheck extends EFOcats_event_addCheck {
  event() {
    super.event();

    this.$('input,select,textarea').on('change', event => {
      $(event.currentTarget)
        .parents('.qa')
        .find('input,select,textarea')
        .each((index, element) => {
          if (!$(element).parents('.check-flag').hasClass('required') || $(element).val() !== '') {
            efocats.validations.check_error($(element), false);
          }
        });
    });
  }
}
